export enum CustomerPSRSummaryDataTest {
  SUMMARY_TC_CHECKBOX = "SUMMARY_TC_CHECKBOX",
  SUMMARY_CONTAINER = "SUMMARY_CONTAINER",
}
